const PublicFooter: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
                <div className="text-center text-gray-600 dark:text-gray-400">
                    <p>&copy; {currentYear} The Brilliance of Blossoms. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default PublicFooter;
